import React, {createContext, useReducer} from 'react'

export const SET_CUSTOMER_LIST = 'SET_CUSTOMER_LIST'
export const SELECT_CUSTOMER = 'SELECT_CUSTOMER'
export const SET_SHOW_CUSTOMER_POPUP = 'SET_SHOW_CUSTOMER_POPUP'
export const UPDATE_CUSTOMER_DATA = 'UPDATE_CUSTOMER_DATA'

const Reducer = (data, payload) => {
  switch (payload.type) {
    case SET_CUSTOMER_LIST:
      return { ...data, customer_list: payload.data }
    case SELECT_CUSTOMER:
      return {
        ...data,
        selected_customer: payload.data.selected_customer,
        show_customer_form: payload.data.show_customer_form,
      }
    case SET_SHOW_CUSTOMER_POPUP:
      return {
        ...data,
        show_customer_form: payload.data,
        selected_customer: payload.data ? data.selected_customer : {},
      }
    case UPDATE_CUSTOMER_DATA:
      return {
        ...data,
        customer_list: data.customer_list.map((customer, index) =>
          index === payload.data.index ? payload.data.customer : customer
        ),
        show_customer_form: false,
      }
    default:
      return data
  }
}

const initialState = {
  customer_list: [],
  selected_customer: {},
  show_customer_form: false,
}

const CustomerStore = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState)

  return (
    <CustomerContext.Provider value={[state, dispatch]}>
      {children}
    </CustomerContext.Provider>
  )
}

export const CustomerContext = createContext(initialState)
export default CustomerStore
